import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormActionsService } from '../../services/forms/form-actions.service';

@Component({
    selector: 'app-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {
    @Input() formGroup;
    @Input() formInputs;
    @Output() submitEvent: EventEmitter<any> = new EventEmitter();
    @Output() cancelFormEvent: EventEmitter<any> = new EventEmitter();

    formSubmitAttempt: boolean = false;

    constructor(
        private formActionService: FormActionsService
    ) { }

    ngOnInit() { }

    ngOnChanges() {
        this.setCallBackFunctions(this.formInputs);
    }

    setCallBackFunctions(formInputs) {
        formInputs.forEach(input => {
            if (input.controlType === "formArray" || input["controlType"] === "formGroup") {
                this.setCallBackFunctions(input.formInputs);
            } else {
                if (input.controlType === "submitButton") {
                    input.callback = this.submit.bind(this);
                } else if (input.controlType === "cancelButton") {
                    input.callback = this.cancel.bind(this);
                }
            }
        });
    }

    cancel(event): void {
        this.formGroup.reset();
        this.cancelFormEvent.emit({ e: event });
    }

    /** 
    * @desc This function will submit the form after checking for all the validations
    */
    submit(event): void {
        this.formSubmitAttempt = !this.formSubmitAttempt;
        if (this.formGroup.valid) {
            this.submitEvent.emit({ e: event, formData: this.formGroup });
        }
    }

     /**
     * This function is used to check error for a given input control
    */
    isInvalid(control, formSubmitted) {
        return this.formActionService.isInvalid(control, formSubmitted);
    }   


}
